import React from 'react';

import moment from 'moment';

import { DeleteIcon } from 'CommonComponents/icons';
import TextButton from 'CommonComponents/TextButton';

import EditIcon from 'Assets/icons/edit.svg';
import EyeIcon from 'Assets/icons/eye.svg';

export default function EvaluationTemplateListTableRow(props) {
    const click = () => {
        window.location.href = props.clickUrl;
    };

    return (
        <tr className="tw-cursor-pointer">
            <td onClick={click}>{props.template.name}</td>
            <td onClick={click}>{props.template.status_label}</td>
            <td onClick={click} className="inbud-numeric-cell">
                {props.template.companies_count}
            </td>
            <td onClick={click} className="inbud-numeric-cell">
                {props.template.scorers_count}
            </td>
            <td onClick={click} className="inbud-date-cell">
                {moment(props.template.created_at).format('DD-MM-YYYY')}
            </td>
            <td>
                <div className="tw-flex tw-items-center tw-gap-x-3">
                    {props.template.status > 0 && (
                        <TextButton onClick={click} customWidth={'tw-min-w-12'}>
                            <EyeIcon className="tw-w-3 tw-h-3" />
                            {$t('View')}
                        </TextButton>
                    )}
                    {parseInt(props.template.status) === 0 && (
                        <TextButton onClick={click} customWidth={'tw-min-w-12'}>
                            <EditIcon className="tw-w-3 tw-h-3" />
                            {$t('Edit')}
                        </TextButton>
                    )}
                    <TextButton onClick={() => props.deleteClick()} variant={'danger'}>
                        <DeleteIcon className="tw-w-3 tw-h-3" />
                        {$t('Delete')}
                    </TextButton>
                </div>
            </td>
        </tr>
    );
}
